


export default class ChartComponent {
  constructor(element) {
    this.el = element
    
   this.dataset = [80,100,56,120,180,30,40,120,160,10,250];
    //this.dataset = [1,5,2,6,2];
    this.datasetLineChart = [
    { 
      x: 1,
      y: 200
    }, 
    {
      x: 2,
      y: 100
    },
    {
      x: 3,
      y: 300
    },
    { 
      x: 4,
      y: 200
    }, 
    {
      x: 5,
      y: 100
    },
    {
      x: 6,
      y: 300
    }
  ];

    this.chartconfig = 
    {
      svgWidth: 800,
      svgHeight: 300,
      barPadding: 5,
    }

    this.createBarChart = this.createBarChart.bind(this);


    this.init()
  }

  init()
  {    
    if(d3)
    {    
    /*   d3.select(".chart-component")
      .selectAll("p")
      .data(this.dataset)
      .enter()
      .append("span")
      .text((d) => {
        return d;
      }) */
      //.text("this is awesome");

      this.createBarChart();

      this.createLineChart();

      var chart = this.BarChart(alphabet, {
        x: d => d.letter,
        y: d => d.frequency,
        yFormat: "%",
        yLabel: "↑ Frequency",
        width: 800,
        height: 500,
        color: "steelblue",
        duration: 750 // slow transition for demonstration
      })
    }
   
  }

  setChartScaleAccordingToData(svg, addScales)
  {
    const {
      svgWidth,
      svgHeight      
    } = this.chartconfig

    // calculate yScale
    this.chartconfig.yScale = d3.scaleLinear()
    .domain([0, d3.max(this.dataset)])
    .range([0, svgHeight]);

    // set xScale
    this.chartconfig.xScale = d3.scaleLinear()
    .domain([0, d3.max(this.dataset)])
    .range([0, svgWidth]); 

    // Optional add scales
    if(addScales)
    {
      var x_axis = d3.axisBottom().
      scale(this.chartconfig.xScale); 
      
      var y_axis = d3.axisLeft()
      .scale(this.chartconfig.yScale);

      svg.append("g")
      .attr("transform", "translate(50,10)")
      .call(y_axis); 

      var xAxisTranslate = svgHeight - 20;

      svg.append("g")
      .attr("transform", `translate(50,${xAxisTranslate})`)
      .call(x_axis); 
    }
  }

  createBarChart()
  { 
    const {
      svgWidth,
      svgHeight,
      barPadding      
    } = this.chartconfig
   
    var barWidth = (svgWidth / this.dataset.length);

    var svg = d3.select("#svg-chart")
    .attr("width", svgWidth)
    .attr("height", svgHeight);
   
    // Adjust scaling according to data
    this.setChartScaleAccordingToData(svg);

    // Create bar columns
    var barChart = svg.selectAll("rect")
    .data(this.dataset)
    .enter()
    .append("rect")
    .attr("y", (d) => {
      return svgHeight - this.chartconfig.yScale(d)
    })
    .attr("height", (d) => {
      return this.chartconfig.yScale(d)
    })
    .attr("width", barWidth - barPadding)
    .attr("transform", (d, i) => 
    {
      var translate = barWidth * i;
      return `translate(${translate}, 0)`;
    });

    // Create text labels for each bar
    var text = svg.selectAll("text")
    .data(this.dataset)
    .enter()
    .append("text")
    .text((d) => 
    {
      return d
    })
    .attr("y", (d, i) => {
      return svgHeight - this.chartconfig.yScale(d) - 5;
    })
    .attr("x", (d, i) => {
      return (barWidth * i) + (barWidth / 3)
    })

  }

  createLineChart()
  {
    const {
      svgWidth,
      svgHeight,            
    } = this.chartconfig 

    var margin = { top: 20, right: 20, bottom: 20, left: 50 };
    var width = svgWidth - margin.left - margin.right;
    var height = svgHeight - margin.top - margin.bottom;


    var svg = d3.select("#svg-chart-line")
    .attr("width", svgWidth)
    .attr("height", svgHeight);
   
    var g = svg.append("g")
    .attr("transform", `translate(${margin.left},${margin.top})`);

    var x = d3.scaleLinear().rangeRound([0, width]);  
    var y = d3.scaleLinear().rangeRound([height, 0]); 

    // create line
    var line = d3.line()
    .x((d, i) => {
      return x(d.x)
    })
    .y((d) => {
      return y(d.y)
    })
    x.domain(d3.extent(this.datasetLineChart, (d) => {
      return d.x
    }))
    y.domain(d3.extent(this.datasetLineChart, (d) => {
      return d.y
    }));

    g.append("g")
    .attr("transform", `translate(0,${height})`)
    .call(d3.axisBottom(x))
    .select(".domain")
    .remove();

    g.append("g")
    .call(d3.axisLeft(y))
    .append("text")
    .attr("fill", "#000")
    .attr("transform", "rotate(-90)")
    .attr("y", 6)
    .attr("dy", "0.71em")
    .attr("text-anchor", "end")
    .attr("Price ($)");


    g.append("path")
    .datum(this.datasetLineChart)
    .attr("fill", "none")
    .attr("stroke", "#FFFFFF")
    .attr("stroke-linejoin", "round")
    .attr("stroke-linecap", "round")
    .attr("stroke-width", 1.5)
    .attr("d", line);
  }


 

}
